export const compactVehicleImg = require("../Assets/images/vehicle-Compact.png");
export const standardVehicleImg = require("../Assets/images/vehicle-Standard.png");
export const suvVehicleImg = require("../Assets/images/vehicle-SUV.png");
export const defaultImg = require("../Assets/images/default-img.jpg");
// NOTE: the original 2940x1960 / 975KB hero source is deliberately no
// longer require()d. Nothing rendered it — the hero is a CSS background —
// but requiring it made CRA copy the full-size file into build/static
// on every deploy. The resized derivatives it produced (hero-900.*,
// hero-1600.*) are referenced from _landing.scss instead. The original
// stays in the repo as the master to re-encode from.
// The phone mockup is a flat UI screenshot, which WebP encodes far better
// than PNG: 106KB -> 18KB for the same pixels.
export const spotAddMobile = require("../Assets/images/spotie-add-spot.webp");

// CRA 5 returns { default, ReactComponent } for SVG requires; PNGs/JPEGs
// return the URL string directly. Peel off .default so <img src={…}> gets
// a plain URL instead of the wrapper object.
//
// These are vector store badges, so the SVGs are both smaller and sharper
// than the PNGs that used to be here. The PNGs were the two heaviest
// assets on the landing page by a wide margin — 1150KB and 404KB, about
// 1.5MB to render two 135px-wide buttons below the hero CTA.
export const playStoreImg = require("../Assets/images/playstore.svg").default;
export const appStoreImg = require("../Assets/images/appstore.svg").default;
